// services/projects_service.js
import axios from 'axios';

//const end_point1 = "http://192.168.30.225:88/api/projects";
//const end_point1 = "https://preprodb.portailachats.ma/api/projects";

const end_point1 = process.env.REACT_APP_API_URL + "/api/projects";

export const show_projects = async () => {
    return await axios.get(`${end_point1}/show_projects`);  
};

export const show_projects_by_creator = async () => {
    return await axios.get(`${end_point1}/show_projects_by_creator`);  
};

export const add_project = async (projectData) => {
    return await axios.post(`${end_point1}/add_project`, projectData);
};


export const update_project = async (projectCode, updatedData) => {
  return await axios.put(`${end_point1}/update_project`,{
    project_code: projectCode,
    ...updatedData,
  });
};


export const archive_project = async (projectCode,archived) => {
  return await axios.put(`${end_point1}/archive`,{ project_code: projectCode,archived:archived });
};

export const getActiveProjects = async () => {
    return await axios.get(`${end_point1}/active_projects`); 
};

export const getActiveProjects_by_direction = async (direction) => {
    return await axios.get(`${end_point1}/active_projects_by_direction/`+direction);
     
};

export const getPurchaseRequestsByProject = async (projectCode) => {
    return await axios.post(`${end_point1}/purchase-requests`,{ project_code: projectCode });
     
};

export const count_projects = async (time_range, user_direction = null) => {
  return await axios.get(`${end_point1}/count_projects/${time_range}/${user_direction}`);
};

export const top5_projects = async (time_range, user_direction = null) => {
  return await axios.get(`${end_point1}/top5/${time_range}/${user_direction}`);
};

export const overbudget_projects = async (time_range, user_direction = null) => {
  return await axios.get(`${end_point1}/projectsOverbudget/${time_range}/${user_direction}`);
};

export const GlobalRate = async (time_range, user_direction = null) => {
  return await axios.get(`${end_point1}/Rate/${time_range}/${user_direction}`);
};

export const assignProjectToRequest = async (requestCode, projectCode) => {
  return await axios.put(`${end_point1}/assign-project`, {
    request_code: requestCode,
    project_code: projectCode
  });
};
